<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelPerfil"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'nomePerfil',
    'filterIdEmpresas',
    'filterProdutoSlotGames'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_perfil_' + this.nomePerfil.toLowerCase(), null);
        return;
      }
      this.$emit('selectChange', 'id_perfil_' + this.nomePerfil.toLowerCase(), e.id);
    },
    labelPerfil({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      let filtro = 'excluido=false ';
      if (this.filterProdutoSlotGames)
        filtro += `AND EXISTS (SELECT 1 FROM json_array_elements(perfil_imposto.configuracao->'impostos') AS imposto WHERE '3' IN (SELECT value::text FROM json_array_elements_text(imposto->'produtosTipo'))) `;
      this.filterIdEmpresas
        ? (filtro += `and id_empresas::jsonb @> '[${this.$store.state.user.info.id_empresa}]'`)
        : (filtro += `and id_empresa=${this.$store.state.user.info.id_empresa}`);

      const nomeMetodo = `perfil_${this.nomePerfil}`;

      this.isLoading = true;
      this.$atenaList
        .getCommon(nomeMetodo, {
          columns: 'id, nome',
          filter: filtro,
          order: 'id'
        })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
          this.isLoading = false;
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (newVal) {
      this.setValue(newVal);
    }
  }
};
</script>

<style lang="scss" scoped></style>
